import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import './../../styles/slider.css';
import { S } from './Slider_Styles';
import { Icon } from '../icon/Icon';

type SlidePropsType = {
    text: string
    userName: string
}

const Slide = (props: SlidePropsType) => {
    return (
        <S.Slide>
        <S.Text>{props.text}</S.Text>
        <S.Name>@{props.userName}</S.Name>
        </S.Slide>
    )
}

const items = [
    <Slide text={"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorem, pariatur itaque. Quis, consequuntur."} 
    userName={"Ainur Ainurov"} />,
    <Slide text={"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorem, pariatur itaque. Quis, consequuntur."} 
    userName={"Nata Nataliva"} />,
    <Slide text={"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorem, pariatur itaque. Quis, consequuntur."} 
    userName={"Ainur Taganov"} />
];

export const Slider = () => (
    <S.Slider>
        <AliceCarousel
            mouseTracking
            items={items}
            

        //     renderPrevButton={()=>{
        //         return <Icon iconId={"react"}/>
        //     }}
         />
         
    </S.Slider>
);



// import React from 'react';
// import { FlexWrapper } from '../FlexWrapper';
// import {S} from './Slider_Styles'

// export const Slider: React.FC = () => {
//     return (
//         <S.Slider>
//             <FlexWrapper>
//                 <S.Slide>
//                     <S.Text>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorem, pariatur itaque. Quis, consequuntur.</S.Text>
//                     <S.Name>@Ainur Taganov</S.Name>
//                 </S.Slide>
//             </FlexWrapper>
//             <S.Pagination>
//                 <span></span>
//                 <span className={"active"}></span>
//                 <span></span>
//             </S.Pagination>
//         </S.Slider>
//     );
// };

